import { Chip, SxProps } from '@mui/material'
import { ProgressTagColor } from 'src/v3/self-paced/utils/progress-display'

export let StatusChip = ({
  label,
  color,
  sx,
}: {
  label: string
  color: ProgressTagColor
  sx?: SxProps
}) => (
  <Chip
    label={label}
    size="small"
    color={color}
    sx={sx ?? { position: 'absolute', top: 8, left: 8 }}
  />
)
